var React = require('react');

function Polygon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1248 1374 9 15h-18z","fill":"#cac7c7","fillRule":"evenodd","data-name":"Polygon 1"}));
}

Polygon.defaultProps = {"width":"18","height":"15","viewBox":"1239 1374 18 15"};

module.exports = Polygon;

Polygon.default = Polygon;
